import { PermissionWithAction } from '@hypeit-gmbh/hypeit-ui-core';
import { PermittedItemType } from '../../common';

type FilterPermittedItemsArgs<
  U extends string,
  T extends PermittedItemType<U>,
> = {
  items: T[];
  hasOneOfPermissions: (permissions: PermissionWithAction<U>[]) => boolean;
};

export const filterPermittedItems = <
  U extends string,
  T extends PermittedItemType<U>,
>({
  items,
  hasOneOfPermissions,
}: FilterPermittedItemsArgs<U, T>): T[] => {
  const getIsPermittedItem = (item: T) =>
    item.requiredPermissions.length === 0 ||
    hasOneOfPermissions(item.requiredPermissions);

  return items.filter(getIsPermittedItem);
};
